import { QuizItemCache } from '../../../../api/quiz/getQuizzes/normalize/toQuizItemCache';
import { Folder } from '../../../../api/quiz/getQuizzes/types';

export const getQuizLibraryFilter =
  (quizFolderPath: string) => (cache: QuizItemCache) =>
    ((cache.itemById[quizFolderPath] as Folder)?.children ?? cache.rootItems)
      .map((itemId) => cache.itemById[itemId])
      .filter((quizOrFolder) => quizOrFolder.deleted === false);
